<template>
    <div class="title-page" :class="{'title-page_hasImg': props.srcImage}">
        <div class="title-page__container">
            <div v-if="props.title && !props.srcImage" class="title-page__title">{{ props.title }}</div>
            <img v-if="props.srcImage" class="title-page__img" :src="props.srcImage" alt="image">
        </div>
    </div>
</template>

<script lang="ts" setup>
    const props = defineProps({
        title: {
            type: [String, null] as PropType<string | null>,
            required: false,
            default: ''
        },
        srcImage: {
            type: [String, null] as PropType<string | null>,
            required: false,
            default: ''
        }
    });
</script>

<style lang="scss">
    @import url("styles.scss");
</style>